<template>
  <div class="list">
    <div
      v-for="(entry, index) in entries"
      :key="index"
      class="entry"
    >
      <div class="entry-leading">
        <slot name="leading">
          <the-icon
            class="file-icon"
            art="regular"
            name="file"
          />
        </slot>
      </div>

      <span v-text="entry.name" />

      <div class="entry-trailing">
        <basic-button
          hierarchy="tertiary"
          :label="$props.buttonLabel"
          size="sm"
          @click="$emit('button-click', index)"
        >
          <template #leading>
            <the-icon
              art="solid"
              :name="$props.buttonIcon"
            />
          </template>
        </basic-button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { logWarning } from '@shared/helpers/Logger'

  import BasicButton from '@shared/components/Basic/Button'

  defineEmits(['button-click'])

  defineProps({
    buttonIcon: {
      type: String,
      required: true,
    },

    buttonLabel: {
      type: String,
      required: true,
    },

    entries: {
      type: Array,
      required: true,
      validator(val) {
        const isValidObj = val.every(obj => Object.hasOwn(obj, 'name'))
        if (!isValidObj) {
          logWarning('[Vue warn]: Invalid prop: entries should have the following properties: {name}')
          return false
        }
        return true
      },
    },
  })
</script>

<style scoped>
.list {
  display: flex;
  flex-direction: column;
}

.entry {
  display: grid;
  grid-template-columns: 1fr;
  padding: var(--fixed-spacing-fix-04) var(--fixed-spacing-fix-06) var(--fixed-spacing-fix-04)
    var(--fixed-spacing-fix-04);
  border-bottom: 1px solid var(--outline-variant);
}

.entry-trailing {
  justify-self: end;
  &:deep(.button) {
    width: auto;
  }
}

@media (--v-medium) {
  .entry {
    grid-template-columns: auto 1fr auto;
    column-gap: var(--fixed-spacing-fix-04);
  }
}
</style>
